import { takeEvery, takeLatest } from 'redux-saga/effects';
import setLocale from './setLocale';
import checkServicesAvailability from './checkServicesAvailability';
import { SET_LOCALE, CHECK_SERVICES_AVAILABILITY } from '../actions';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';

export default function* watchSystem() {
  yield takeEvery(SYSTEM_MODULE + SET_LOCALE, setLocale);
  yield takeLatest(SYSTEM_MODULE + CHECK_SERVICES_AVAILABILITY, checkServicesAvailability);
}
